import styled from 'styled-components';

const PostInformationContainer = styled.section`
  padding: ${props => props.theme.paddings.pd * 1.5}px;
`;

export default PostInformationContainer;
